import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-[#050A1F] to-[#0B112E] text-white overflow-hidden relative">
      
      {/* Floating background glow */}
      <motion.div
        className="absolute w-[600px] h-[600px] bg-purple-500/10 rounded-full blur-3xl"
        animate={{
          x: [0, 100, -100, 0],
          y: [0, 50, -50, 0],
        }}
        transition={{ repeat: Infinity, duration: 18 }}
      />

      {/* Rotating ring */}
      <motion.div
        className="relative mb-8"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
      >
        <div className="w-24 h-24 rounded-full border-4 border-t-cyan-400 border-l-purple-600 border-r-transparent border-b-transparent" />
      </motion.div>

      {/* Booting text */}
      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent"
      >
        Booting <span className="text-cyan-400">Vidra</span> System
      </motion.h1>

      {/* Animated dots */}
      <div className="flex space-x-2 mt-4">
        {[0, 1, 2].map((dot) => (
          <motion.span
            key={dot}
            className="w-3 h-3 bg-cyan-400 rounded-full"
            animate={{ opacity: [0.2, 1, 0.2] }}
            transition={{
              repeat: Infinity,
              duration: 1.2,
              delay: dot * 0.2,
            }}
          />
        ))}
      </div>

      {/* Fun tagline */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="mt-6 text-gray-400 text-sm"
      >
        Initializing AI modules 🤖 ... Please wait
      </motion.p>
    </div>
  );
}
